const INITIAL_ERRORS = {
  deviceId: '',
  replacementDeviceId: '',
  reasons: '',
  describes: {},
  patientImpact: '',
  dateOfEvent: '',
};

const NO_REPLACEMENT_OPTION = {
  label: 'No replacement',
  value: 'No replacement',
};

export { INITIAL_ERRORS, NO_REPLACEMENT_OPTION };
